import { callInternal } from './internal.js';

export interface PlayTokenChannel {
	device_id?: string | number;
	device_token?: string;
	channel_id?: string | number;
	device_auto_id?: string | number;
	play_type?: string | number;
	rate?: unknown;
	rates?: unknown;
	cloud?: unknown;
	[k: string]: unknown;
}

export interface PlayTokenData {
	live?: PlayTokenChannel;
	back?: PlayTokenChannel;
	playback?: PlayTokenChannel;
	customer?: string | number;
	[k: string]: unknown;
}

export async function fetchPlayToken(opts: {
	deviceAutoId: string | number;
	channelId?: string | number;
}): Promise<PlayTokenData | null> {
	const res = await callInternal<PlayTokenData>({
		short_name: 'base',
		action: '/play/play_token',
		method: 'GET',
		query: {
			device_auto_id: String(opts.deviceAutoId),
			channel_id: String(opts.channelId ?? 1),
		},
		av: '1.1',
	});
	if (Number(res.code) !== 0 || !res.data || typeof res.data !== 'object') return null;
	return res.data;
}

export function tokenDeviceId(token: PlayTokenData | null | undefined, kind: 'live' | 'playback' = 'live'): string {
	const channel = kind === 'playback'
		? token?.back ?? token?.playback ?? token?.live
		: token?.live ?? token?.back ?? token?.playback;
	return text(channel?.device_id);
}

function text(value: unknown): string {
	if (value === undefined || value === null) return '';
	return String(value).trim();
}
